<template>
  <div id="app">
    <v-webTop ref="top"></v-webTop>
    <v-webLogo v-bind:isHiddenLogo="isHiddenLogo"></v-webLogo>
    <v-webTabbar
      ref="tabbar"
      v-bind:isHidden="isHidden"
      v-if="!g_userInfo || (g_userInfo && !g_userInfo.head)"
    ></v-webTabbar>
    <div class="routerview">
      <router-view />
    </div>
    <v-webFoot
      v-bind:isHiddenFoot="isHiddenFoot"
      v-if="!g_userInfo || (g_userInfo && !g_userInfo.head) "
    ></v-webFoot>
    <v-loading ref="loading"></v-loading>
    <v-confirm ref="confirm"></v-confirm>
    <v-msg ref="msg"></v-msg>
  </div>
</template>
<script>
import webTop from '@/components/webTop.vue';
import webLogo from '@/components/webLogo.vue';
import webTabbar from '@/components/webTabbar.vue';
import webFoot from '@/components/webFoot.vue';
import Loading from '@/components/popup/Loading';
import Confirm from '@/components/popup/Confirm';
import Msg from '@/components/popup/Msg';
import { req_userInfo } from '@/services/user';

export default {
  name: 'App',
  components: {
    'v-webTop': webTop,
    'v-webLogo': webLogo,
    'v-webTabbar': webTabbar,
    'v-webFoot': webFoot,
    'v-loading': Loading,
    'v-confirm': Confirm,
    'v-msg': Msg,
  },
  watch: {
    $route(to, from) {
      if (!this.$refs.tabbar){
       this.istabbar = true
        this.$refs.tabbar.func_tabbarUp();
      } else {
        this.$refs.tabbar.func_tabbarUp();
      }
      this.func_route();
      this.$refs.loading.vLod_Change(false);
    },
  },
  data() {
    return {
      isHidden: false,
      isHiddenLogo: false,
      isHiddenFoot: false,
      g_userInfo: false,
      isorder: true,//默认true  chbaojia相反
      istabbar:false,//默认false  chbaojia相反,如果是chbaojia  需要v-if istabbar
    };
  },
  methods: {
    handleBeforeUnload() {
      // 清除登录缓存的逻辑
      this.clearLoginCache();
    },
    clearLoginCache() {
      // 这里写清除登录缓存的代码，例如清除localStorage或sessionStorage中的项
      // localStorage.removeItem("g_userInfo");
      // 其他需要清除的缓存项...
    },
    loadingChange(show, title) {
      this.$refs.loading.vLod_Change(show, title);
    },
    confirmChange(
      status,
      content,
      affirm,
      cancel,
      btn,
      caption,
      address,
      index,
      Mobile,
      UserWord
    ) {
      this.$refs.confirm.vCon_Change(
        status,
        content,
        affirm,
        cancel,
        btn,
        caption,
        address,
        index,
        Mobile,
        UserWord
      );
      // this.$parent.confirmChange('success', '确认删除购物车中所有产品？', () => {}, () => {}, {yes:'确定', no:'取消'});
    },
    msgChange(status, title, content, timer) {
      this.$refs.msg.vMsg_Change(status, title, content, timer);
    },
    // 监听路由变化
    func_route() {
      const to = this.$route['name'];
      const hidden_payges = [
        'register',
        'settlement',
        'onlinePay',
        'customLogin',
        'bj',
        'Retrieve',
      ];
      if (hidden_payges.indexOf(to) !== -1) {
        this.isHidden = true;
        this.isHiddenLogo = true;
        this.isHiddenFoot = true;
      } else {
        this.isHidden = false;
        this.isHiddenLogo = false;
        this.isHiddenFoot = false;
      }
    },
    // 主线登录流程
    func_appLogin(userinfo) {
      if (!userinfo) return;
      // 缓存登录用户数据
      this.g_userInfo = userinfo;
      this.STORAGE.set('g_userInfo', userinfo);
      this.STORAGE.remove('worker');
      // 通知顶部栏
      this.$refs.top.func_top_login();
    },
    func_appLoginwithworker(userinfo, worker) {
      if (!userinfo) return;
      // 缓存登录用户数据
      this.g_userInfo = userinfo;
      this.STORAGE.set('g_userInfo', userinfo);
      this.STORAGE.set('worker', worker);
      // 通知顶部栏
      this.$refs.top.func_top_login();
      this.istabbar = false
    },
    // 主线登出流程
    func_appLoginOut() {
      this.g_userInfo = false;
      this.STORAGE.remove('g_userInfo');
      this.STORAGE.remove('g_trollerList');
      // 通知顶部栏
      this.$refs.top.func_top_login();
      if (this.isorder){
        this.$refs.tabbar.func_tabbarUp(true);
      }

      if (this.$route.path.indexOf('home') !== -1) {
        // 当前页是首页-刷新
        location.reload();
      } else {
        // 当前页不是首页-跳转到首页
        this.$router.push({
          name: 'home',
        });
      }
    },
    // 请求更新缓存用户信息
    async func_appUpdateUserinfo() {
      const result = await req_userInfo(this.g_userInfo['userid']);
      if (result.success) {
        this.g_userInfo = result.data;
        this.STORAGE.set('g_userInfo', result.data);
      }
    },
    // 接受产品oef，传到tabbar中执行产品切换
    func_webTab_offerClass(oef) {
      return this.$refs.tabbar.func_toOffer(oef);
    },
    // 更新购物车数量
    func_tabbar_trolley() {
      this.$refs.tabbar.func_tabbarUp(true);
    },
    beforeDestroy() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
  },
  mounted() {
    window.document.body.style.backgroundColor = '#f0f2f5';
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    if (!window.localStorage) {
      alert(
        '当前浏览器环境异常。该浏览器隐私模式下，不兼容此网站使用，请切换正常版本！（360浏览器，请点击浏览器右上角菜单，退出无痕浏览模式。）'
      );
      return;
    } else if (window.ActiveXObject !== undefined) {
      alert(
        '当前环境为"360浏览器-兼容模式"，该环境下无法正常使用本网站。如需继续使用该浏览器，请点击浏览器上方切换模式至极速模式。'
      );
      return;
    }
    // 测试2
    /* if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
			alert('phone');
		} else {
			alert('pc');
		} */

    this.func_route();

    const userinfo = this.STORAGE.get('g_userInfo');
    if (userinfo) this.func_appLogin(userinfo);
  },
};
</script>
<style>
/* #app {
	/* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
/* font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale; */
/* text-align: center; */
/* color: #2c3e50; */
/* margin-top: 60px; */
/* padding-bottom:26px; */
/* } */
* {
  margin: 0;
  padding: 0;
}
img {
  -webkit-user-select: none;
  user-select: none;
}
input {
  outline: none;
  box-sizing: border-box;
  padding: 0 11px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  transition: border-color 0.2s linear 0s;
}
input::-webkit-input-placeholder {
  color: #aeaeae;
}
input:hover {
  border-color: #bbbbbb;
}
input:focus {
  border-color: #ff6801;
}
@media only screen and (min-width: 480px) {
  .routerview {
    min-height: 80vh;
    margin-bottom: 26px;
  }
}
@media only screen and (max-width: 480px) {
  .routerview {
    min-height: 95vh;
    margin-bottom: 26px;
  }
}
</style>
<style src='./style/main.css'></style>



// WEBPACK FOOTER //
// src/App.vue